import React, { CSSProperties } from "react";
import Select from "react-select";
import "./InputSelect.css";
import cn from "classnames";
import { twMerge } from "tailwind-merge";

interface Props {
  options: Array<SelectOption>;
  value: string | number | null;
  id?: string;
  label?: string;
  descriptionLabel?: string;
  ariaLabel?: string;
  isClearable?: boolean;
  isLoading?: boolean;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
  hasError?: boolean;
  required?: boolean;
  disabled?: boolean;
  style?: CSSProperties;

  onChange(item: SelectOption): void;
}

export type SelectOption<T = string | number> = {
  label: string;
  value: T | null;
  icon?: string | null;
};

export const InputSelect = ({
                              options,
                              value,
                              isClearable,
                              isLoading,
                              placeholder,
                              ariaLabel,
                              onChange,
                              className,
                              containerClassName,
                              hasError,
                              disabled,
                              style
                            }: Props) => {
  const onChangeInternal = (e: any) => {
    onChange(e as SelectOption);
  };

  return (
    <div className={twMerge(cn("min-w-[200px]", containerClassName))} style={style}>
      <Select
        menuPortalTarget={document.body}
        closeMenuOnSelect={true}
        classNamePrefix={"react-select_2"}
        aria-label={ariaLabel}
        value={
          value
            ? {
              value: value,
              label:
                options.find((o) => o.value == value)?.label ?? "loading..."
            }
            : null
        }
        styles={{
          control: (style, props) => {
            const styles = {
              ...style,
              borderColor: hasError ? "red" : style.borderColor
            };

            if (props.isDisabled) {
              styles.backgroundColor = "#e9ecef";
            }
            return styles;
          },
          singleValue: (style, props) => {
            const styles = {
              ...style
            };
            if (props.isDisabled) {
              styles.color = "black";
            }
            return styles;
          },
          multiValue: (style, props) => {
            const styles = {
              ...style
            };
            if (props.isDisabled) {
              styles.backgroundColor = "#e9ecef";
            }
            return styles;
          }
        }}
        options={options as any}
        isClearable={isClearable}
        isLoading={isLoading}
        placeholder={placeholder}
        isDisabled={disabled}
        className={cn(className)}
        menuPosition={"fixed"}
        onChange={onChangeInternal}
      />
    </div>
  );
};
